(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name CitaController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('CitaController', CitaController);

    CitaController.$inject = ["CitaService","$sce","$filter","$location","$timeout","$scope"];

    function CitaController(CitaService,$sce,$filter,$location,$timeout,$scope)
      {
  
          var vm = this;
          vm.cita = CitaService;

          vm.send = false;
          vm.error = false;
          vm.errorsigno = false;
          vm.hora_selected = false;
          vm.errorcita = false;
          vm.sendCita = false;
          vm.listasempty = false;
          vm.loadingDC = false;

          vm.cita_info = null;

          vm.cita_eliminada = false;
          
          if(sessionStorage.getItem('correoElectronico'))
            vm.cita.email = sessionStorage.getItem('correoElectronico');

          vm.citaHoraSelected = function(selected) {
              vm.errorcita = false;
              vm.hora_selected = selected;
              //console.log("seleccionado");    
          };

          vm.imprimir_cita = function(cita)
          {
            if(cita)
            {
              vm.cita.imprimir_cita.CodigoCita = cita;
              vm.cita.CitaPau_Imprimir_Cita(vm.cita).then(function(data)
              {
                console.log(data)
                 vm.cita_info = data;
                 vm.cita.map = $sce.trustAsResourceUrl('https://mapes.oxigensalud.com/web_oxigensalud/solicitudcitapau?latitud='+vm.cita_info.latitudPau.replace(",",".")+'&longitud='+vm.cita_info.longitudPau.replace(",","."));
              })
            }

          }


          vm.borrar_cita = function(cita)
          {
            vm.cita_eliminada = false;
            if(cita)
            {
              vm.cita.eliminar_cita.CodigoCita = cita;
              vm.cita.CitaPau_Eliminar_Cita(vm.cita).then(function(data)
              {
                vm.loadingDC = true;
                $timeout(function(){
                    location.reload();
                    vm.loadingDC = false;
                },3000)
                vm.cita_eliminada = true;
              })
            }

          }

          vm.loginSubmit= function()
          {
            vm.send = true;
          	vm.cita.CitaPau_Login(vm.cita).then(function(data)
          	{  
          		//ERROR ZONE
          		if(data.codigoError)
          		{
                vm.send = false;
                if(data.codigoError == "E501")
                {
                    vm.error = true;
                }

          		}else{
              
                vm.error = true;
                vm.send = false;
                sessionStorage.setItem('CodigoTratamiento', data.codigoTratamiento);
         			  sessionStorage.setItem('correoElectronico', data.correoElectronico);
          			vm.cita.paus.CodigoTratamiento=data.codigoTratamiento;
          			vm.cita.paus.Idioma=data.idioma;

                if (vm.cita.paus.CodigoTratamiento) {
                  vm.error = false;
                  console.log(data);
                  
          			  window.location.href = data.slugAppointment;
                  vm.send = false;
                }else{
                  //ERROR ZONE
                }
              }

          		
          	},function(error){

          	});

          }

          console.log(CodigoCita);
          if(CodigoCita!="")
            vm.loginSubmit();
          
          vm.pausSubmit = function()
          {

          	if(sessionStorage.getItem('CodigoTratamiento'))
          		vm.cita.paus.CodigoTratamiento=sessionStorage.getItem('CodigoTratamiento');
            	vm.cita.CitaPau_Paus(vm.cita).then(function(data)
            	{
            		//ERROR ZONE
            		if(vm.cita.paus.CodigoTratamiento == '')
            		{ 
                  window.location.href = data.slugLogin;
                  //console.log(data.slugLogin);
            		}else{
            			vm.cita.listaPaus = data.listaPaus;
            		}
            		
            	},function(error){

          	});
          }


          vm.guardar_cita = function()
          {
            if(sessionStorage.getItem('CodigoTratamiento'))
              vm.cita.guardar_cita.CodigoTratamiento=sessionStorage.getItem('CodigoTratamiento');
              
              vm.cita.guardar_cita.Dia = $filter("date")(vm.datestamp,'dd/MM/yyyy'); 
              vm.cita.guardar_cita.Pau =  vm.cita.calendario.Pau;
              vm.cita.guardar_cita.Hora = vm.cita.hora;
              vm.cita.guardar_cita.Email = vm.cita.email;
              vm.cita.guardar_cita.Comentario = vm.cita.comentario;
            
            vm.cita.CitaPau_Guardar_Cita(vm.cita).then(function(data)
            {
              //ERROR ZONE
              if(data.codigoError == "E500")
              {
                  vm.errorcita = true;
            
                  //console.log( vm.errorcita);
          
                  if (vm.errorcita) {
                    vm.cita.hora ='';
                    vm.hora_selected = ''
                  }

              }else{

                //vm.cita.listaPaus = data.listaPaus;
                vm.sendCita = true;
                $timeout(function(){
                    location.reload();
                },3000)
                //console.log(data);  
                //console.log("cita guardado correctamente");  
              }

            },function(error){

            });
          }


          vm.pauInfo = function()
          {
            for (var i = 0; i < vm.cita.listaPaus.length; i++) {
              if(vm.cita.listaPaus[i].id ==vm.cita.calendario.Pau)
                return vm.cita.listaPaus[i];
            }
            return {};
          }

          vm.setTimepicker = function()
          {

            if(moment(vm.datestamp).format('DD/MM/yyyy') == "Fecha inválida" || typeof vm.datestamp =="string")
              return ;
       
            vm.datestampPrint = vm.datestamp;
            vm.cita.horas.Dia = moment(vm.datestamp).format('DD/MM/yyyy');
            vm.cita.horas.Pau = vm.cita.calendario.Pau;

            vm.cita.CitaPau_Calendario_Horas(vm.cita).then(function(data)
            { 
              //ERROR ZONE
              if(data.codigoError){

              }else{
                 //console.log(vm.cita.listaHoras);
                vm.cita.listaHoras = data.listaHoras;
                $scope.horas = vm.cita.listaHoras.length;
               // console.log(vm.cita.listaHoras);
                if (vm.cita.listaHoras.length === 0) {
                    vm.listasempty = true;
                }else{
                     vm.listasempty = false;
                }

              }
            },function(error){

            });

          }

          vm.load = false;
          
          vm.listaDias = [];
          vm.calendarioSubmit = function()
          {
            vm.errorcita = false;
            vm.cita.pauSelected = vm.pauInfo();
            // console.log('https://mapes.oxigensalud.com/web_oxigensalud/solicitudcitapau?latitud='+vm.cita.pauSelected.latitud.replace(",",".")+'&longitud='+vm.cita.pauSelected.longitud.replace(",","."));
            vm.cita.map = $sce.trustAsResourceUrl('https://mapes.oxigensalud.com/web_oxigensalud/solicitudcitapau?latitud='+vm.cita.pauSelected.latitud.replace(",",".")+'&longitud='+vm.cita.pauSelected.longitud.replace(",","."));
            vm.load = true;
            vm.cita.CitaPau_Calendario_Dias(vm.cita).then(function(data)

            {

              vm.listaDias = data.listaDias;
             // angular.forEach(vm.listaDias, function(value, key){
             //   console.log(value.abierto);
             //   scope.abierto[] = value.abierto;
             // });
              //console.log("listaDias",vm.listaDias);
              vm.load = false;
              //ERROR ZONE
              if(data.codigoError)
              {

              }else{
                //vm.cita.listaPaus = data.listaPaus;
                vm.datestamp =false;
                  data.listaDias.forEach(dia =>  {
                    if (dia.abierto == 1 && vm.datestamp == false) {
                      vm.datestamp =  parseInt(moment(dia.diaVisita, "DD/MM/YYYY").format("x"));
                      console.log(dia.diaVisita);
                    }else{
                      // console.log(dia.diaVisita);
                    }
                  });
                //vm.datestamp =  parseInt(moment(data.listaDias[0].diaVisita, "DD/MM/YYYY").format("x"));

                
                // console.log(vm.datestamp); 
                vm.setTimepicker();
                $timeout(function(){
                  jQuery(".datepicker ").pickadate("set").set("select",vm.datestamp)  
                },250)
                
              }
              
            },function(error){

            });
          }



      }

})();